import React, { ReactElement } from "react";
import StockOutProductSummaryWithDateReportList from "../../components/Reports/StockOutProductSummaryWithDateReport";
import MainLayout from "../../components/Layouts";

const StockOutProductSummaryWithDateReportPage = (): ReactElement => {
  return (
    <MainLayout>
      <StockOutProductSummaryWithDateReportList />
    </MainLayout>
  );
}; 

export default StockOutProductSummaryWithDateReportPage;
